import { mapAppLocale } from '@protector/utils/app-locale-map';
import { getMomentLocaleSpecification } from 'config/moment-locale-specification';
import { getCurrentLanguage } from 'core/utils/functions';
import moment from 'moment';
import 'moment/dist/locale/de';
import 'moment/dist/locale/el';
import 'moment/dist/locale/es';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/hu';
import 'moment/dist/locale/it';
import 'moment/dist/locale/pl';
import 'moment/dist/locale/pt';
import 'moment/dist/locale/pt-br';
import 'moment/dist/locale/ru';

moment.defineLocale('pt-pt', { parentLocale: 'pt' });

const locale = mapAppLocale(getCurrentLanguage());

moment.updateLocale(locale, getMomentLocaleSpecification(locale));

// This module installs a runtime guard on moment.locale. It must be imported
// before any other code that calls moment.locale(value) so the override is in
// place (see the side-effect import at apps/web/src/index.tsx).
const originalLocaleFn = moment.locale.bind(moment);
let localeGuardEnabled = true;

export const setMomentLocale = (newLocale: string, config?: moment.LocaleSpecification) => {
  localeGuardEnabled = false;
  try {
    if (config) {
      originalLocaleFn(newLocale, config);
    } else {
      originalLocaleFn(newLocale);
    }
  } finally {
    localeGuardEnabled = true;
  }
};

const guardedLocale = (...args: unknown[]) => {
  if (args.length > 0 && args[0] !== undefined) {
    if (localeGuardEnabled) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('moment.locale(...) is guarded. Use setMomentLocale() from config/moment-import instead.');
      }
      return originalLocaleFn();
    }
    return originalLocaleFn(...(args as Parameters<typeof originalLocaleFn>));
  }
  return originalLocaleFn();
};

Object.defineProperty(moment, 'locale', {
  value: guardedLocale,
  writable: false,
  configurable: false
});
